import(/* webpackMode: "eager", webpackExports: ["CompareShell"] */ "/vercel/path0/src/components/landing/CompareChrome.tsx");
